module.exports = __webpack_public_path__ + "static/bode-a9f6fb8a4000a6e5417671c07d173c1e.png";